import { Typography } from '@mui/material';
import PublicToolLayout from '../../components/public-tools/PublicToolLayout';
import ConsolidatedReportWidget from '../../components/public-tools/ConsolidatedReportWidget';

export default function ConsolidatedReportPage() {
  return (
    <PublicToolLayout title="Full SEO Report">
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Full SEO Diagnostic Report
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Get a single consolidated report covering all 7 diagnostics — Website Health, Page SEO,
        robots.txt, Sitemap, GSC Verification Signals, Schema, and AI Search Readiness. We run them all and
        deliver the report to your email, usually within 3 hours.
      </Typography>
      <ConsolidatedReportWidget />
    </PublicToolLayout>
  );
}
